const RELOAD_PREFIX = "gp-chunk-reload:";

export const isStaleChunkError = (error) => {
    const message = String(error?.message || error || "");
    return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|dynamically imported module/i.test(message);
};

const chunkKey = (value) => {
    const text = String(value || "unknown");
    const match = text.match(/https?:\/\/\S+\.js/i) || text.match(/assets\/\S+\.js/i);
    return RELOAD_PREFIX + (match ? match[0] : text.slice(0, 180));
};

export const reloadForStaleChunk = (value) => {
    if (typeof window === "undefined") {
        return false;
    }
    const key = chunkKey(value);
    try {
        if (sessionStorage.getItem(key)) {
            return false;
        }
        sessionStorage.setItem(key, String(Date.now()));
    } catch {
        return false;
    }
    window.location.reload();
    return true;
};

export const installStaleChunkRecovery = () => {
    if (typeof window === "undefined" || window.__gpStaleChunkRecovery) {
        return;
    }
    window.__gpStaleChunkRecovery = true;

    window.addEventListener("vite:preloadError", (event) => {
        event.preventDefault();
        reloadForStaleChunk(event?.payload || event);
    });

    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.addEventListener("message", (event) => {
            if (event.data?.type === "CHUNK_MISSING") {
                reloadForStaleChunk(event.data.url);
            }
        });
    }
};
